import script from "./EditMeetingTurnSlideOver.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMeetingTurnSlideOver.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__